import React, { use, useEffect, useState } from 'react';
import { fetchRandomImages } from '../utils/api';

/**
 * A component that displays a continuous horizontal marquee of images.
 */
const ImageMarquee = () => {
  const [randomImages, setRandomImages] = useState([]);

  useEffect(() => {
    const getRandomImages = async () => {
      try {
        const randomImagesData = await fetchRandomImages(10);
        console.log(`Fetched random images: ${randomImagesData}`);
        
        setRandomImages(randomImagesData);
      } catch (error) {
      } finally {
      }
    };

    getRandomImages();
  }, []);

  const goToImage = (path, title) => {
    if (path.includes('/')) {
      window.open(`${path.split('/')[0]}?id=${title}`, '_self');
    } else {
      window.open(`${path.split('\\')[0]}?id=${title}`, '_self');
    }
  }

  // Duplicate images to create a seamless loop
  const duplicatedImages = [...randomImages, ...randomImages];

  return (
    <div className="relative w-full overflow-hidden py-4 bg-background-light rounded-lg shadow-inner">
      <style>
        {`
        @keyframes scroll-left {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .marquee-content {
          display: flex;
          width: fit-content; /* Allow content to dictate width */
          animation: scroll-left 40s linear infinite; /* Adjust duration for speed */
        }
        .marquee-item {
          flex-shrink: 0; /* Prevent items from shrinking */
          margin-right: 1rem; /* Space between images */
          border-radius: 0.5rem;
          overflow: hidden;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }
        .marquee-item img {
          width: 200px; /* Fixed width for images */
          height: 150px; /* Fixed height for images */
          object-fit: contain;
        }
        `}
      </style>
      <div className="marquee-content">
        {duplicatedImages.map((img, index) => (
          <div key={index} className="marquee-item cursor-pointer">
            <img
              src={img.imageSrc}
              alt={`Marquee Item ${index}`}
              onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/200x150/CCCCCC/333333?text=Image+Unavailable"; }}
              onContextMenu={(e) => e.preventDefault()}
              onDragStart={(e) => e.preventDefault()}
              onClick={() => goToImage(img.path, img.title)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageMarquee;
